import { AddressDto, BaseEntityDto, PriceDto, TenantDto } from '@fleet-beat/core';
import { CompanySubscription } from '@fleet-beat/api';

export interface CompanyDto extends BaseEntityDto {
  id?: string;
  ownerId?: string;
  tenantId?: string;
  tenant?: TenantDto;
  name?: string;
  email?: string;
  phone?: string;
  address?: AddressDto;
  logoUrl?: string;
  timezone?: string;
  usdot?: string;
  telegramNotificationsEnabled?: boolean;
  priceId?: string;
  price?: PriceDto;
  subscription?: CompanySubscription;
}

export interface CompanyOwnerDto extends BaseEntityDto {
  name: string;
  ovmsOwnerSecret: string;
}
